import { render, staticRenderFns } from "./StatisticsByCountry.vue?vue&type=template&id=50d7f892&scoped=true&"
import script from "./StatisticsByCountry.vue?vue&type=script&lang=js&"
export * from "./StatisticsByCountry.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsByCountry.vue?vue&type=style&index=0&id=50d7f892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7f892",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
